<li>
  <a
    class="item"
    routerLinkActive="active-route"
    [routerLink]="item().link"
    [class.item--narrow]="isNarrowDisplay()"
    [suiTooltip]="isNarrowDisplay() ? (item().label | translate) : undefined"
    (keydown.enter)="navigateTo(item().link)"
  >
    <sui-icon class="item__icon" [name]="item().icon"></sui-icon>

    <div class="item__label">{{ item().label | translate }}</div>
  </a>
</li>
